module.exports = __webpack_public_path__ + "img/Z60Q_15.50de9ffd.jpg";